/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.scheduler.detail.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.calendar',
  'acme.common.service.ganttTransform',
  'acme.common.service.themesHelper',
  'acme.common.directive.gantt',
  'checklist-model',
  'acme.common.service.userPreferences',
  'acme.view.application.resources.modals.assign.controllers'
])
.controller('SchedulerDetailController', ['$scope', '$state', '$timeout', '$uibModal', '$filter', 'CalendarService', 'ApiService', 'ThemesHelperService', 'GanttTransformService', 'UserPreferencesService', function ($scope, $state, $timeout, $uibModal, $filter, CalendarService, ApiService, ThemesHelperService, GanttTransformService, UserPreferencesService) {

    $scope.schedulerDetail = {

      // Set to the currently selected resource and the associated event
      currentSelectedResource: {
        task: null,
        event: null
      },

      // For UX, tracks which events are "open" in the Gantt
      openEventList: [],
      emailSetting: 'always',
      company: ThemesHelperService.getCompany(),

      availableResourceList: [],

      calendarControl: {
        currentTime: null,
        currentTimeDisplay: '',
        currentScale: 'd',

        startTime: new Date(),
        endTime: new Date(),

        showCalendar: false,
        isPreferenceLoaded: false,
        dateOptions: {
          formatYear: 'yy',
          startingDay: UserPreferencesService.getStartDayOfWeek(),
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          showWeeks: false
        },

        dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),

        // Third party hook
        scalerModule: null,

        toggleCalendar: function ($event) {
          $event.preventDefault();
          $event.stopPropagation();

          this.showCalendar = true;
        },

        // Handles controls on either side of the date
        next: function () {
          var ct = this.currentTime;
          switch (this.currentScale) {
            case 'd':
              ct.setDate(ct.getDate() + 1);
              break;
            case 'w':
              ct.setDate(ct.getDate() + 7);
              break;
            case 'm':
              ct.setMonth(ct.getMonth() + 1);
              break;
          }

          this.update();
        },

        previous: function () {
          var ct = this.currentTime;
          switch (this.currentScale) {
            case 'd':
              ct.setDate(ct.getDate() - 1);
              break;
            case 'w':
              ct.setDate(ct.getDate() - 7);
              break;
            case 'm':
              ct.setMonth(ct.getMonth() - 1);
              break;
          }

          this.update();
        },

        setApiRange: function () {
          this.startTime = new Date(this.currentTime);
          this.endTime = new Date(this.currentTime);

          // Based on the scale and current time, we set the start/end for the API calls
          switch (this.currentScale) {
            case 'd':
              this.startTime.setHours(0, 0, 0, 0);
              this.endTime.setHours(23, 59, 59, 999);
              break;
            case 'w':
              var startEnd = this.startAndEndOfWeek(this.currentTime);
              this.startTime = startEnd[0];
              this.endTime = startEnd[1];
              break;
            case 'm':
              this.startTime = new Date(this.currentTime.getFullYear(), this.currentTime.getMonth(), 1);
              this.endTime = new Date(this.currentTime.getFullYear(), this.currentTime.getMonth() + 1, 0);
              break;
          }
        },

        // Show the scale based on the current selection
        setScaleDisplay: function () {
          this.currentTimeDisplay = $filter('date')(this.currentTime, UserPreferencesService.getDateFormat('extendedDate', 'dateFormat'));
        },

        // Reset the display/scale to today
        today: function () {
          this.currentScale = 'd';
          this.currentTime = new Date();
          this.setScale(this.currentScale);
        },

        setScale: function (s) {
          this.currentScale = s;
          if (this.scalerModule !== null) {
            this.scalerModule(s);
          }
          this.update();
        },

        init: function (scalerFunc) {
          this.scalerModule = scalerFunc;
          this.currentScale = 'd';
          this.currentTime = new Date();

          // Use the selected time from the event calendar
          if (CalendarService.current.hasOwnProperty('eventsStartTimeTracker')) {
            this.currentTime = CalendarService.current.eventsStartTimeTracker;
          }

          this.update();
          $scope.$on('UserPreferencesService:onDateFormatLoad', $scope.schedulerDetail.calendarControl.onDateFormatLoad);
          $timeout(function () {
            $scope.schedulerDetail.calendarControl.isPreferenceLoaded = true;
          }, 100);

        },

        update: function () {
          // refresh start/end and display
          this.setApiRange();
          this.setScaleDisplay();
        },

        startAndEndOfWeek: function (date) {
          var now = date;

          // set time to some convenient value
          now.setHours(0, 0, 0, 0);

          // Get the previous Monday
          var monday = new Date(now);
          monday.setDate(monday.getDate() - monday.getDay() + 1);

          // Get next Sunday
          now.setHours(23, 59, 59, 999);
          var sunday = new Date(now);
          sunday.setDate(sunday.getDate() - sunday.getDay() + 7);

          // Return array of date objects
          return [monday, sunday];
        },
        onDateFormatLoad: function (e, data) {
          var self = $scope.schedulerDetail.calendarControl;
          self.dateFormat = UserPreferencesService.getDateFormat('shortDate', 'dateFormat');
          self.dateOptions = {
            formatYear: 'yy',
            startingDay: UserPreferencesService.getStartDayOfWeek(),
            formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
          };
          self.setScaleDisplay();
          self.isLoaded = true;
        }
      },

      currentDate: new Date(),

      resourceEnums: {},

      model: {
        data: []
      },

      // 'soft' -> ganttRefresh, 'hard' -> parse, false -> nothing
      ganttRefresh: false,

      ganttLoading: true,

      filterOptions: {
        status: {
          1: 'Unfulfilled events only',
          2: 'Fullfilled events only',
          3: 'All Events (sorted by time)'
        },
        events: {},
        category: [],
        department: []
      },

      currentFilters: {
        assignment: 3,
        events: [],
        category: [],
        department: []
      },

      apiHelper: {

        currentParent: null,
        currentFieldSelection: null,

        loading: false,

        fetchEvents: function () {
          $scope.schedulerDetail.ganttLoading = true;
          var cc = $scope.schedulerDetail.calendarControl;
          ApiService.event.gantt(cc.startTime, cc.endTime).then(this.events.success, this.events.error);
        },

        fetchResources: function () {
          ApiService.resource.available.event(
            $scope.schedulerDetail.currentSelectedResource.task.available_query,
            $scope.schedulerDetail.currentSelectedResource.event.internal_id).then(this.resources.fetchSuccess, this.resources.error);
        },

        assignResource: function (newSelection) {

          // Save the new selection for gantt update
          this.currentFieldSelection = newSelection;

          // Grab the query for this resource and add the selected resource id
          var query = $scope.schedulerDetail.currentSelectedResource.task.available_query;

          query.assign = true;
          if (newSelection === null) {
            query.assign = false;
          } else {
            query.id = newSelection.id;
          }

          return ApiService.resource.assignment.event(
            query,
            $scope.schedulerDetail.currentSelectedResource.event.internal_id);
        },

        resources: {
          fetchSuccess: function (response) {

            $scope.schedulerDetail.apiHelper.loading = false;

            var available = response.data.payload;

            // Clean the last pass of data
            while ($scope.schedulerDetail.availableResourceList.length > 0) {
              $scope.schedulerDetail.availableResourceList.pop();
            }

            for (var i = 0; i < available.length; i++) {
              var entry = {
                id: available[i].id,
                name: available[i].name
              };

              $scope.schedulerDetail.availableResourceList.push(entry);
            }

            $scope.schedulerDetail.assignResource();
          },

          assignSuccess: function (request) {

            var self = $scope.schedulerDetail,
              currentTask = self.currentSelectedResource.task,
              currentFieldSelection = self.currentSelectedResource.task;

            // Assignment complete, repaint the chart
            if (currentFieldSelection != null && request.resourceName) {

              // Update and refresh
              currentTask.text = request.resourceName + ', ' + currentTask.r_type;
              currentTask.internal_id = currentFieldSelection.id;
              currentTask.name = request.resourceName;
              currentTask.fulfilled = true;

              // Remove unfulfilled link
              if (gantt.isLinkExists(currentTask.id)) {
                gantt.deleteLink(currentTask.id);
              }

            } else {

              currentTask.text = currentTask.r_type;
              currentTask.internal_id = null;
              currentTask.name = currentTask.r_type;
              currentTask.fulfilled = false;

            }

            // Check to see if the current resource is not fulfilled
            if (!self.currentSelectedResource.task.fulfilled) {
              self.chart.addFulfillLink(self.currentSelectedResource.event);
            }

            self.ganttRefresh = 'soft';

            return true;

          },

          error: function (error) {
            $scope.schedulerDetail.apiHelper.loading = false;
            console.log("assign breaks", error);
          }
        },

        events: {
          success: function (resp) {

            console.log("event", resp);

            var eventList = resp.payload.events;
            var typeList = resp.payload.resourceTypes;

            // Clean the last pass of data
            while ($scope.schedulerDetail.filterOptions.department.length > 0) {
              $scope.schedulerDetail.filterOptions.department.pop();
            }

            while ($scope.schedulerDetail.model.data.length > 0) {
              $scope.schedulerDetail.model.data.pop();
            }

            $scope.schedulerDetail.filterOptions.events = {};

            while ($scope.schedulerDetail.filterOptions.category.length > 0) {
              $scope.schedulerDetail.filterOptions.category.pop();
            }

            // We have events to process and render
            if (eventList.length > 0) {

              // Process the resource types adding a lookup
              if (typeList !== undefined) {
                $scope.schedulerDetail.resourceEnums = typeList;
                for (var j = 0; j < typeList.length; j++) {
                  $scope.schedulerDetail.filterOptions.category.push(typeList[j].resourceCategory);
                  $scope.schedulerDetail.currentFilters.category.push(typeList[j].resourceCategory);

                  // Keep a record of each type for the filter
                  for (var k = 0; k < typeList[j].types.length; k++) {
                    $scope.schedulerDetail.filterOptions.department.push(typeList[j].types[k]);
                    $scope.schedulerDetail.currentFilters.department.push(typeList[j].types[k]);
                  }
                }
              }

              // Transform the data to Gantt consumable
              var eventSet = [];
              for (var i = 0; i < eventList.length; i++) {
                var te = GanttTransformService.event(eventList[i]);
                $scope.schedulerDetail.model.data.push(te.event);
                $scope.schedulerDetail.model.data.push.apply($scope.schedulerDetail.model.data, te.resources);

                // We use the template id in order to filter on all selected events and only show one of each template
                // TODO maybe change to object for direct assignment
                if (eventSet.indexOf(te.event.template_id) === -1) {
                  eventSet.push(te.event.template_id);
                  $scope.schedulerDetail.filterOptions.events[te.event.template_id] = te.event.text;
                  $scope.schedulerDetail.currentFilters.events.push(te.event.template_id);
                }
              }
            }

            // Notify the directive we have a full refresh
            $scope.schedulerDetail.ganttRefresh = 'hard';

            // Nudge angular
            $scope.$apply(function () {
            });
          },

          error: function (resp) {

          }
        }
      },

      init: function () {

        // One time configuration
        if (typeof(gantt) === 'object') {

          // Initialize the scale control and pass the gantt-specific resize function
          $scope.schedulerDetail.calendarControl.init(this.chart.setScale);

          // Wrapped in a timeout to allow for the gantt to paint
          setTimeout(function () {

            var self = $scope.schedulerDetail;

            // Initialize all the events associated with actions in the chart
            self.chart.events();

            // Request events from the API
            self.apiHelper.fetchEvents();

            $scope.$watch('schedulerDetail.currentFilters', function () {
              // Watch the filters for changes and then fire refreshData,
              // which will fire the onBeforeTaskDisplay event below
              // We always wait for a false to avoid a double refresh
              if ($scope.schedulerDetail.ganttRefresh === false) {
                $scope.schedulerDetail.ganttRefresh = 'soft';
              }
            }, true);

            // Display loading notice
            $scope.$on('gantt::loading', function (e, loading) {
              $scope.schedulerDetail.ganttLoading = loading;
            });

          }, 10);
        }

        if (this.company.hasOwnProperty('notificationPreference')) {
          this.emailSetting = this.company.notificationPreference;
        }

        $scope.$emit('Application::contentTitleChange', {
          title: "Scheduler"
        });
      },

      next: function () {
        var self = $scope.schedulerDetail;

        self.calendarControl.next();
        self.apiHelper.fetchEvents();
      },

      previous: function () {
        var self = $scope.schedulerDetail;

        self.calendarControl.previous();
        self.apiHelper.fetchEvents();
      },

      scale: function (s) {
        var self = $scope.schedulerDetail;

        if (s == 'd') {
          CalendarService.current.defaultView = s == 'w' ? 'agendaWeek' : 'month';
          CalendarService.current.eventsStartTimeTracker = self.calendarControl.currentTime;
          $state.go('application.programs.list');
        } else {
          self.calendarControl.setScale(s);
          self.apiHelper.fetchEvents();
        }
      },

      today: function () {
        var self = $scope.schedulerDetail;

        self.calendarControl.today();
        self.apiHelper.fetchEvents();
      },

      isToday: function () {
        var today = this.currentDate,
          date = (new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)).getTime(),
          startDate = (new Date(this.calendarControl.startTime.getFullYear(), this.calendarControl.startTime.getMonth(), this.calendarControl.startTime.getDate(), 0, 0, 0)).getTime();

        console.log('isToday', date, startDate, this.calendarControl.startTime);
        return (startDate === date);
      },

      calendar: function () {
        var self = $scope.schedulerDetail;

        self.calendarControl.update();
        self.apiHelper.fetchEvents();
      },

      chart: {

        populateExtras: function () {
          var data = $scope.schedulerDetail.model.data;
          for (var i = 0; i < data.length; i++) {
            if (data[i].is_event) {
              // this.appendResourceAdd(data[i].id); // TODO removed for now
              this.addFulfillLink(data[i]);
            }
          }
        },

        addFulfillLink: function (parent) {
          var childrenIds = gantt.getChildren(parent.id);
          for (var i = 0; i < childrenIds.length; i++) {
            var child = gantt.getTask(childrenIds[i]);
            if (!child.fulfilled) {
              gantt.addLink({
                id: child.id,
                source: parent.id,
                target: child.id,
                type: 1
              });
            }
          }
        },

        appendResourceAdd: function (parent) {

          var theParent = gantt.getTask(parent);

          var addResourceTask = {
            id: theParent.id + '-add',
            text: '+ Add Resource',
            start_date: theParent.start_date,
            duration: theParent.duration,
            is_event: false,
            fulfilled: true
          };

          gantt.addTask(addResourceTask, parent);
        },

        setScale: function (scale) {
          switch (scale) {
            case 'd':
              gantt.config.scale_unit = "hour";
              gantt.config.date_scale = "%g%a";
              gantt.config.scale_height = 50;
              gantt.config.subscales = [
                {unit: "minute", step: 15, date: ":%i"}
              ];
              gantt.templates.date_scale = null;

              break;
            case 'w':
              var weekScaleTemplate = function (date) {
                var dateToStr = gantt.date.date_to_str("%d %M");
                var endDate = gantt.date.add(gantt.date.add(date, 1, "week"), -1, "day");
                return dateToStr(date) + " - " + dateToStr(endDate);
              };

              gantt.config.scale_unit = "week";
              gantt.config.step = 1;
              gantt.templates.date_scale = weekScaleTemplate;
              gantt.config.subscales = [
                {unit: "day", step: 1, date: "%D %j"}
              ];
              gantt.config.scale_height = 50;
              break;
            case 'm':
              gantt.config.scale_unit = "month";
              gantt.config.date_scale = "%F, %Y";
              gantt.config.subscales = [
                {unit: "day", step: 1, date: "%j"}
              ];
              gantt.config.scale_height = 50;
              gantt.templates.date_scale = null;
              break;
          }

          gantt.render();
        },

        events: function () {

          gantt.attachEvent("onBeforeTaskDisplay", function (id, task) {
            return $scope.schedulerDetail.updateFilters(id, task);
          });

          // Open reassignment/add resource modal
          gantt.attachEvent("onTaskClick", function (id, e) {

            e.stopPropagation();

            var self = $scope.schedulerDetail;

            // Open an event on click
            var task = gantt.getTask(id);

            // Scroll to task
            var taskPos = gantt.getTaskPosition(task, task.start_date, task.end_date);
            gantt.scrollTo(taskPos.left - gantt.config.task_scroll_offset, taskPos.top);

            if (task.is_event) {
              // Clunky as there is no "is open/closed" property
              if (self.openEventList.indexOf(id) == -1) {
                gantt.open(id);
                self.openEventList.push(id);
              } else {
                gantt.close(id);
                self.openEventList.splice(self.openEventList.indexOf(id), 1);
              }

            } else {
              // Handle any task/resource assignment changes
              self.currentSelectedResource.task = task;
              self.currentSelectedResource.event = gantt.getTask(task.parent);
              if (!self.apiHelper.loading) {
                self.apiHelper.loading = true;
                self.apiHelper.fetchResources();
              }
            }
          });

          gantt.attachEvent("onGanttRender", function () {
            // Need to wait till the chart is re-painted to load the icons and assignment lines
            $scope.schedulerDetail.chart.populateExtras();
          });
        }
      },

      clearFilters: function () {
        var self = $scope.schedulerDetail;

        self.currentFilters.assignment = 3;
        self.currentFilters.events = Object.keys(self.filterOptions.events);
        self.currentFilters.category = self.filterOptions.category.slice(0);
        self.currentFilters.department = self.filterOptions.department.slice(0);
      },

      // Updates all filters
      updateFilters: function (id, task) {
        // Show by default
        var result = true;

        // Events
        var eventFilter = $scope.schedulerDetail.currentFilters.events;
        if (eventFilter.length > 0) {
          if (task.is_event) {
            result = eventFilter.indexOf(task.template_id) != -1;
          } else {
            var taskParent = gantt.getTask(task.parent);
            result = eventFilter.indexOf(taskParent.template_id) != -1;
          }
        }

        // Assignment
        var assignmentFilter = $scope.schedulerDetail.currentFilters.assignment;
        switch (assignmentFilter) {
          // Unfulfilled events only
          case '1':
            if (task.fulfilled || (task.is_event && task.$source.length === 0 )) {
              result = false;
            }
            break;
          // Fullfilled events only
          case '2':
            if (task.is_event) {
              result = task.$source.length === 0;
            } else {
              var parent = gantt.getTask(task.parent);
              result = task.fulfilled && parent.$source.length === 0;
            }
            break;
        }

        // Resource Category
        if (!task.is_event && result === true) {
          var categoryFilter = $scope.schedulerDetail.currentFilters.category;

          if (task.r_category !== undefined) {
            result = categoryFilter.indexOf(task.r_category.toString()) != -1;
          }

          var departmentFilter = $scope.schedulerDetail.currentFilters.department;
          if (task.r_type !== undefined) {
            if (result) {
              result = departmentFilter.indexOf(task.r_type) != -1;
            }
          }
        }

        return result;
      },

      assignResource: function () {

        var self = $scope.schedulerDetail;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/resources/modals/assign/assign.tpl.html',
          size: 'lg',
          controller: 'ResourcesModalsAssignController',
          resolve: {
            request: function () {
              return self.currentSelectedResource.task.request;
            },
            emailSetting: function() {
              return self.emailSetting;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (request) {
          self.apiHelper.resources.assignSuccess(request);
        }, function () {
          // Do nothing
        });
      }

    };

    $scope.schedulerDetail.init();

  }])
  .controller('SchedulerDetailModalController', ['$scope', '$timeout', '$uibModalInstance', 'currentTask', 'resourceEnums', 'availableResourceList', 'apiHelper', function ($scope, $timeout, $uibModalInstance, currentTask, resourceEnums, availableResourceList, apiHelper) {

// Resolved values
    $scope.currentTask = currentTask;
    $scope.enums = resourceEnums;
    $scope.apiHelper = apiHelper;
    $scope.resourceList = null;

    $scope.currentAssignment = null;
    $scope.fieldSelection = null;

    $scope.isSubmitted = false;

    $scope.search = '';

    $scope.showTypes = false;
    $scope.selectListFocus = true;

    $scope.currentType = $scope.currentTask.r_type;
    $scope.currentCategory = $scope.currentTask.r_category;
    $scope.selectedCategory = $scope.currentTask.r_category;

    $scope.init = function () {
      // Base is assignment needs to change

      // Already assigned
      if ($scope.currentTask.fulfilled) {
        $scope.fieldSelection = $scope.currentTask;
      }

      // Totally not assigned
      if ($scope.currentTask.internal_id !== null) {
        $scope.currentAssignment = $scope.currentTask.name;
      }
      $scope.resourceList = $scope.sortResources(availableResourceList);

      console.log('SchedulerDetailModalController::init', $scope.selectListFocus);
    };

    $scope.changeCategory = function (newCategory) {
      $scope.currentCategory = $scope.enums[newCategory];
    };

    $scope.sortResources = function (list) {
      var r = 0;

      list.sort(function (a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          r = -1;
        } else {
          r = 1;
        }
        return r;
      });

      console.log('SchedulerDetailModalController::sortResources', list);
      return list;
    };
    $scope.selectResourceType = function (resourceType) {
      $scope.currentTask.r_category = $scope.selectedCategory;
      $scope.currentTask.r_type = resourceType;

      // TODO c/p
      $scope.currentType = $scope.enums[$scope.currentTask.r_category].types[$scope.currentTask.r_type];
      $scope.currentCategory = $scope.currentTask.r_category;

      $scope.showTypes = false;
    };

    $scope.selectResource = function (resource) {
      $scope.fieldSelection = resource;
    };

    $scope.clearResource = function () {
      $scope.fieldSelection = null;
    };

    $scope.fieldSelected = function (id) {
      var currSelection = $scope.fieldSelection;
      if (currSelection != null && currSelection.id == id) {
        return true;
      }
      return false;
    };

    $scope.done = function () {
      $scope.isSubmitted = true;

      // Try to assign the resource
      $scope.apiHelper.assignResource($scope.fieldSelection).then(
        $scope.assignment,
        function (error) {
          console.log("assignresource error");
        }
      );
    };

    $scope.errors = [];

    $scope.assignment = function (response) {
      // Let the helper handle the response
      var result = $scope.apiHelper.resources.assignSuccess(response);

      // If assignment was successful, close modal, otherwise show error
      if (result === true) {
        $scope.success($scope.model);
      } else {
        $scope.errors.push('Unable to assign resource');
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.fieldSelection);
    };

    $scope.closeError = function (index) {
      $scope.errors.splice(index, 1);
    };


    $scope.init();
  }]);